import { render } from "./HeadTip.vue?vue&type=template&id=6857f72a&scoped=true&ts=true"
import script from "./HeadTip.vue?vue&type=script&lang=ts"
export * from "./HeadTip.vue?vue&type=script&lang=ts"

import "./HeadTip.vue?vue&type=style&index=0&id=6857f72a&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6857f72a"]])

export default __exports__